"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RE_COLOR = exports.RE_COLOR = /^(#?([0-9a-f]{3}|[0-9a-f]{6})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d.]+%?\))$/i;

var RE_RHYTHM_UNITS = exports.RE_RHYTHM_UNITS = /^-?\d*\.?\d*ru$/;

var RE_START_OF_LINE = exports.RE_START_OF_LINE = /^/gm;

var RE_WHITESPACE = exports.RE_WHITESPACE = /\s+/;

var RE_PERCENT_NUMBER = exports.RE_PERCENT_NUMBER = /^\d+%$/;

var RE_CAPITAL_LETTERS = exports.RE_CAPITAL_LETTERS = /([A-Z])/g;

var RE_MEDIA_QUERY_STRING = exports.RE_MEDIA_QUERY_STRING = /^@media /;

var RE_RADIAL_GRADIENT = exports.RE_RADIAL_GRADIENT = /^radial-gradient\(.+\)$/;

var RE_LINEAR_GRADIENT = exports.RE_LINEAR_GRADIENT = /^linear-gradient\(.+\)$/;

var RE_URL = exports.RE_URL = /^url\(.+\)$/;

var RE_UNNESTED_COMMA = exports.RE_UNNESTED_COMMA = /,(?![^()]*(?:\([^()]*\))?\))/g;

var RE_ARGUMENTS_OF_CSS_FUNCTION = exports.RE_ARGUMENTS_OF_CSS_FUNCTION = /^(?:[a-zA-Z\-_\d]*)\((.*)\)$/g;

var RE_CSS_FUNCTION_NAME = exports.RE_CSS_FUNCTION_NAME = /^([a-zA-Z-]*)\(.*\)$/;

var RE_UNNESTED_WHITESPACE = exports.RE_UNNESTED_WHITESPACE = /\s(?![^()]*\))/g;

var RE_COLOR_NAME = exports.RE_COLOR_NAME = /^c:(.*)$/;

// Note we exclude values starting `data:` as they might be images
var RE_TOKEN = exports.RE_TOKEN = /^(?!(?:data|http|https):)([a-zA-Z\-_\d]*):(.*)$/;

var RE_CSS_FUNCTION = exports.RE_CSS_FUNCTION = /^[a-zA-Z-]*\(.*\)$/;

var RE_TRANSFORM_TRANSLATE_FUNCTION = exports.RE_TRANSFORM_TRANSLATE_FUNCTION = /^translate(?:x|y|z|3d)?\(.*\)$/;

var RE_CALC_FUNCTION = exports.RE_CALC_FUNCTION = /^calc\(.*\)$/;

var RE_CALC_VALUES = exports.RE_CALC_VALUES = /(-*[0-9a-z.%]+)/g;

var RE_MODIFIED_MQ = exports.RE_MODIFIED_MQ = /^(?![<@][^<\s]*<)(?!^<default)(?:[@<>]?[a-zA-Z\d]+(?:(?:[+-])\d*\.?\d*(?:em)?)?)(?:<[a-zA-Z\d]+(?:(?:\+|-)\d*\.?\d*(?:em)?)?)?$/;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/const/regexp.js
// module id = 242
// module chunks = 168707334958949